import { render, staticRenderFns } from "./UserNotificationsForm.vue?vue&type=template&id=e6a5244a&scoped=true&"
import script from "./UserNotificationsForm.vue?vue&type=script&lang=js&"
export * from "./UserNotificationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a5244a",
  null
  
)

export default component.exports